import SHPaymentCard from '../../../components/SHPaymentCard/SHPaymentCard';

export default function SHEventPayment({ subTotal, tickets, setActiveTab }) {

    return (
        <div className="sh-info-main" style={{ height: 'fit-content' }}>
            <div style={{ width: "100%", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <SHPaymentCard setActiveTab={setActiveTab} payPrice={subTotal} items={tickets} />
            </div>
        </div >
    )
}
